import { atom } from "jotai";

import type { AppBarVariant } from "./types";

export type State = null | {
  scrollOverVariant: AppBarVariant | null;
};

export const appBarAtom = atom<State>(null);
